var map = {
	"./car.svg": "d5fc",
	"./clothing.svg": "04bf",
	"./donation.svg": "a0a9",
	"./food.svg": "ab2f",
	"./leisure.svg": "d2d2",
	"./other.svg": "029f",
	"./pets.svg": "5a28",
	"./pharma.svg": "2ea9",
	"./public-transportation.svg": "685c0",
	"./super.svg": "f2e9",
	"./tourism.svg": "231e",
	"./tracking-categories-no-selection.svg": "96e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1f38";